import { updatePolicyScan } from './policy-scan-service';
import { IMasLifeSavedQuoteInfo, IPolicyScan } from 'types';

export const masRequestCallback = (
  policyScanId: string,
  policyId: string,
  phone: string,
  createdBy?: string,
  successPage: number = 4,
  formValues: Record<string, any> = {},
): Promise<any> => {
  const now = new Date().toISOString();
  return updatePolicyScan({
    id: policyScanId,
    sk: policyId,
    createdBy,
    masSavedQuoteInfo: {
      ...formValues,
      phone,
      page: successPage,
      callbackRequestedAt: now,
    },
    callbackRequestedAt: now,
    callbackProviderName: 'MAS',
  } as unknown as IPolicyScan);
};

// Partial-update path: send only id, sk and masLifeSavedQuoteInfo (<10 top-
// level keys). The API replaces the whole attribute — always send it in full.
export const masLifeSaveQuoteInfo = (
  policyScanId: string,
  policyId: string,
  masLifeSavedQuoteInfo: IMasLifeSavedQuoteInfo,
): Promise<any> =>
  updatePolicyScan({
    id: policyScanId,
    sk: policyId,
    masLifeSavedQuoteInfo,
  } as unknown as IPolicyScan);
